import { render, staticRenderFns } from "./PopupCamera.vue?vue&type=template&id=0dd1aa5d"
import script from "./PopupCamera.vue?vue&type=script&lang=js"
export * from "./PopupCamera.vue?vue&type=script&lang=js"
import style0 from "./PopupCamera.vue?vue&type=style&index=0&id=0dd1aa5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports